import { message } from "antd";
import axios from "axios";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { getBookingDetail } from "../../../ducks/actions";
import type { TorRulesFormValues } from "./types";
import { apiV1Endpoint } from "../../../../../../api/v1/endpoints";

export const useSaveTorRules = () => {
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);

  const saveTorRules = useCallback(
    async (leaseId: string, values: TorRulesFormValues) => {
      setIsSaving(true);
      try {
        const response = await axios.post(`${apiV1Endpoint}/booking/leaseTorRules`, {
          leaseId,
          torRuleCondition: values.torRuleCondition,
          torRules: values.torRules,
        });

        if (response?.data?.code !== 201) {
          throw new Error("Unexpected response code");
        }

        message.success("TOR rules submitted successfully!");
        await dispatch(getBookingDetail(leaseId) as any);
        return true;
      } catch (error) {
        console.error("Error posting TOR rules:", error);
        message.error("Failed to submit TOR rules, please try again.");
        return false;
      } finally {
        setIsSaving(false);
      }
    },
    [dispatch],
  );

  return { saveTorRules, isSaving };
};
